import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  container: {
    padding: rem(24),
    backgroundColor: theme.white,
    borderRadius: rem(12),
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.08)",
    maxWidth: rem(480),
    width: "100%",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: rem(16),
  },

  title: {
    fontSize: rem(20),
    fontWeight: 700,
    color: theme.colors.gray[9],
    lineHeight: 1.4,
  },

  closeButton: {
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: rem(8),
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.colors.gray[0],
      transform: "rotate(90deg)",
    },
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: rem(14),
  },

  message: {
    fontSize: rem(15),
    lineHeight: 1.6,
    color: theme.colors.gray[7],
  },

  thankYou: {
    fontSize: rem(15),
    lineHeight: 1.6,
    marginTop: rem(8),
    color: theme.colors.gray[7],
  },
}));
